(() => {
  const key = 'lh-favourites-v2';
  const aliases = {lh001: 'emerald-cut-ring', lh002: 'marquise-ring', lh003: 'emerald-cut-stud-earrings'};
  const valid = value => typeof value === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value) && value.length < 200;
  const normalise = value => aliases[value] || value;
  const parse = raw => {
    const values = JSON.parse(raw || '[]');
    return new Set(Array.isArray(values) ? values.map(normalise).filter(valid).slice(0, 200) : []);
  };
  const withLimit = async (items, limit, build) => {
    const result = new Array(items.length);
    let cursor = 0;
    await Promise.all(Array.from({length: Math.min(limit, items.length)}, async () => {
      while (cursor < items.length) {
        const index = cursor++;
        result[index] = await build(items[index]);
      }
    }));
    return result;
  };
  let saved = new Set(), persistent = true;
  try {
    const current = localStorage.getItem(key);
    saved = parse(current ?? localStorage.getItem('lh-saved-designs-v1'));
    if (current === null) localStorage.setItem(key, JSON.stringify([...saved]));
  } catch { persistent = false; }
  const collection = document.querySelector('[data-saved-collection]');
  const grid = collection?.querySelector('[data-favourites-grid]');
  const status = collection?.querySelector('[data-save-status]');
  const records = new Map();
  const root = collection?.dataset.productRoot || window.Shopify?.routes?.root || '/';
  const productUrl = handle => root + 'products/' + encodeURIComponent(handle);
  let generation = 0;
  const refresh = async () => {
    const version = ++generation;
    document.querySelectorAll('[data-save-design]').forEach(button => {
      const selected = saved.has(normalise(button.dataset.saveDesign));
      button.setAttribute('aria-pressed', String(selected));
      button.textContent = selected ? button.dataset.savedLabel : button.dataset.saveLabel;
    });
    document.querySelectorAll('[data-saved-count]').forEach(node => { node.textContent = String(saved.size); });
    if (!grid) return;
    grid.replaceChildren();
    collection.querySelector('[data-saved-empty]').hidden = saved.size > 0;
    status.textContent = persistent ? '' : collection.dataset.storageWarning;
    let failed = false;
    const cards = await withLimit([...saved], 4, async handle => {
      let product;
      try {
        if (!records.has(handle)) records.set(handle, fetch(productUrl(handle) + '.js', {credentials: 'same-origin'}).then(response => {
          if (!response.ok) throw new Error('Product unavailable');
          return response.json();
        }));
        product = await records.get(handle);
      } catch { records.delete(handle); failed = true; }
      const card = document.createElement('article'); card.className = 'product-card';
      const link = document.createElement('a'); link.href = productUrl(handle);
      if (product?.featured_image) {
        const source = new URL(product.featured_image, location.origin);
        if (source.protocol === 'https:') {
          source.searchParams.set('width', '720');
          const image = document.createElement('img'); image.src = source.href; image.alt = product.title; image.loading = 'lazy'; image.width = image.height = 720; link.append(image);
        }
      }
      const title = document.createElement('h2'); title.textContent = product?.title?.split(' — ')[0] || handle.replaceAll('-', ' '); link.append(title); card.append(link);
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'lh-save-button'; remove.textContent = collection.dataset.removeLabel; remove.setAttribute('aria-label', collection.dataset.removeLabel + ': ' + title.textContent);
      remove.addEventListener('click', () => toggle(handle)); card.append(remove);
      return card;
    });
    if (generation !== version) return;
    grid.replaceChildren(...cards);
    if (failed) status.textContent = [status.textContent, collection.dataset.loadError].filter(Boolean).join(' ');
  };
  const toggle = handle => {
    if (!valid(handle)) return;
    if (saved.has(handle)) saved.delete(handle); else if (saved.size < 200) saved.add(handle);
    try { localStorage.setItem(key, JSON.stringify([...saved])); } catch { persistent = false; }
    refresh();
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-save-design]');
    if (button) toggle(normalise(button.dataset.saveDesign));
  });
  addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    try { saved = parse(event.newValue); refresh(); } catch {}
  });
  document.addEventListener('shopify:section:load', refresh);
  refresh();
  const panel = document.querySelector('[data-size-notes]');
  if (!panel) return;
  const form = panel.querySelector('form'), message = panel.querySelector('[data-size-status]');
  const sizeKey = 'lh-size-note-v1';
  try {
    const note = JSON.parse(localStorage.getItem(sizeKey) || 'null');
    if (note && ['UK', 'EU', 'US'].includes(note.system) && typeof note.size === 'string') { form.elements.system.value = note.system; form.elements.size.value = note.size.slice(0, 40); }
  } catch {}
  form.addEventListener('submit', event => {
    event.preventDefault();
    try { localStorage.setItem(sizeKey, JSON.stringify({system: form.elements.system.value, size: form.elements.size.value.trim().slice(0, 40)})); message.textContent = message.dataset.saved; }
    catch { message.textContent = message.dataset.error; }
  });
  panel.querySelector('[data-size-clear]').addEventListener('click', () => {
    try { localStorage.removeItem(sizeKey); form.reset(); message.textContent = message.dataset.cleared; }
    catch { message.textContent = message.dataset.error; }
  });
})();



